/* eslint-disable max-len */
const React = require('react');
const CarouselSnapped = require('@andes/carousel-snapped');
const { getEventTracker } = require('../../../../../../utils/event-tracker');
const { isYellowBlueLightBrand } = require('../../../../../../utils/isYellowBlueLightBrand');
const { CarouselSnappedSlide } = CarouselSnapped;
const Thumbnail = require('@andes/thumbnail');

const Platform = ({ Icon, link, linkMessage, tracking, i18n, index, isMobile, brand }) => {
  const Tracker = getEventTracker();

  const sendToMelidata = (data) => {
    Tracker.melidata.send('/developers/click_platforms', {
      product_name: data,
    }, {
      autoDocsRefInfo: true,
    });
  };

  return (
    <>
      <CarouselSnappedSlide
        className="platforms-slide-container"
        index={index}
        key={`carousel__slide ${index}`}
        >
        <Thumbnail
          hierarchy="neutral"
          size="96">
          <Icon />
        </Thumbnail>
        <a
          href={link}
          target="_self"
          rel="noreferrer"
          className={`text-a ${isYellowBlueLightBrand(brand) ? 'text-rebranding' : ''}`}
          onClick={() => {
            Tracker.send('mpdevelopers/click_platforms', tracking);
            sendToMelidata(tracking);
          }}
          style={{ width: isMobile ? 'auto' : '104%', textAlign: 'center' }}
      >
          {i18n.gettext(linkMessage)}
        </a>
      </CarouselSnappedSlide>
    </>
  );
};

module.exports = Platform;
